var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',[_vm._v("Satisfaction")]),_c('a-rate',{staticStyle:{"font-size":"24px"},attrs:{"default-value":_vm.dataSuccess.ticketpoint,"disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }